import { render } from "./FilterChips.vue?vue&type=template&id=5c3ec09e"
import script from "./FilterChips.vue?vue&type=script&lang=js"
export * from "./FilterChips.vue?vue&type=script&lang=js"

import exportComponent from "/Users/heidbyte/code/GitHub/festivalkult/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__